import { render, staticRenderFns } from "./About.vue?vue&type=template&id=58315422&"
import script from "./About.vue?vue&type=script&lang=ts&"
export * from "./About.vue?vue&type=script&lang=ts&"
import style0 from "./About.vue?vue&type=style&index=0&id=58315422&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports